// LIBRARIES
import styled from "styled-components";

// MISC
import { FONTS, WIDTH } from "constants/styleVariables";

export const LockerStatisticsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-left: 80px;
  margin-top: 40px;
  @media (${WIDTH.mediumWidth}) {
    margin-left: 0px;
  }
`;

export const ContainerTitle = styled.div`
  font-family: ${FONTS.montserrat};
  font-size: 20px;
  font-weight: bold;
`;

export const LockerStatisticsWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;
